// src/utils/authService.js
import {
  createUserWithEmailAndPassword,
  signOut as firebaseSignOut,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { auth, db } from "../firebase";
import { createManagerNotification } from "./notifications";

// ---------------- SIGN UP ----------------
export async function signupWithEmail(userData) {
  const { fullName, email, password, union, requestedRole } = userData;
  
  if (!fullName || !email || !password || !union || !requestedRole) {
    throw new Error("All required fields must be filled");
  }

  if (password.length < 6) {
    throw new Error("Password must be at least 6 characters");
  }

  const cred = await createUserWithEmailAndPassword(auth, email, password);

  const userDoc = {
    fullName,
    email,
    union,
    requestedRole,        // save what they requested
    role: 'pending',      // default to pending
    approved: false,      // admin/manager must approve
    createdAt: serverTimestamp(),
  };

  await setDoc(doc(db, "users", cred.user.uid), userDoc);

  // Notify managers about new signup
  await createManagerNotification(
    "New Member Registration",
    `${fullName} (${email}) has registered as a ${requestedRole} and is awaiting approval.`,
    union
  );

  // IMPORTANT: sign user out immediately
  await firebaseSignOut(auth);

  return cred.user;
}

// ---------------- SIGN IN ----------------
export function signinWithEmail(email, password) {
  return signInWithEmailAndPassword(auth, email, password);
}

// ---------------- SIGN OUT ----------------
export function signout() {
  return firebaseSignOut(auth);
}
